import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FeedbackEvent } from '@bonusly/common-feedback';
import { Button, Flex, Modal, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, rem } from '@bonusly/design-system';
import { useDispatch } from '@bonusly/events';

interface ManagerFeedbackProps {
	isOpen: boolean;
	onClose: VoidFunction;
}

export const ManagerFeedbackModal: FC<ManagerFeedbackProps> = ({ onClose, isOpen }) => {
	const { t } = useTranslation('recognition');
	const dispatch = useDispatch();

	const onClickGiveFeedback = () => {
		onClose();
		dispatch(FeedbackEvent.OpenUnsolicited);
	};

	const onClickAskForFeedback = () => {
		onClose();
		dispatch(FeedbackEvent.OpenRequest);
	};

	return (
		<Modal autoFocus={false} isOpen={isOpen} onClose={onClose} scrollBehavior="inside" size="2xl">
			<ModalOverlay />
			<ModalContent>
				<ModalHeader borderBottomWidth={rem(1)} borderColor="border.default" borderStyle="solid" color="text.default">
					{t('manager_feedback.title')}
				</ModalHeader>
				<ModalCloseButton size="lg" borderRadius="full" />
				<Flex flexDirection="row" alignItems="stretch" align="stretch" alignContent="stretch" gap={2} mx={8} my={3}>
					<FeedbackOptionButton text={t('manager_feedback.give_feedback')} onClick={onClickGiveFeedback} />
					<FeedbackOptionButton text={t('manager_feedback.request_feedback')} onClick={onClickAskForFeedback} />
				</Flex>
			</ModalContent>
		</Modal>
	);
};

const FeedbackOptionButton = ({ text, onClick }: { text: string; onClick: VoidFunction }) => {
	const hoverStyle = {
		_hover: {
			bg: 'hashtag.bgAlphaHover',
		},
	};

	return (
		<Button
			bgColor="hashtag.bgAlpha"
			borderRadius="sm"
			variant="alpha"
			textColor="black"
			width="50%"
			height="140px"
			fontWeight="medium"
			fontSize={100}
			onClick={onClick}
			whiteSpace="normal"
			{...hoverStyle}
		>
			{text}
		</Button>
	);
};
